import React, {useState} from "react";
import styles from "./rename/Rename.module.scss"
import Input from "../../../../Componnets/Input/Input";
import Button from "../../../../Componnets/Button/Button";

const Rename = ({ fileName, onSave, isLoading = false }) => {

  const [inputValue, setInputValue] = useState(fileName);

  const handleOnChange = (e) => {
    setInputValue(e.target.value);
  }

  return (
    <div className={`d-flex ${styles.Rename}`}>
      <div>
        <Input label={"Name"} name={"name"} value={inputValue} onChange={handleOnChange} />
      </div>
      <div>
        <Button block title={"Save"} onClick={() => onSave(inputValue)} disabled={isLoading}/>
      </div>
    </div>
  )
};

export default Rename;